import { IEditYapePromotionRequest } from 'core/model/interfaces/yape/yape.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IYapeState } from '../types';

export const editYapePromotion = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/editYapePromotion`,
  async (data: IEditYapePromotionRequest) => {
    try {
      await apiService.yape.editYapePromotion(data);
      notificationService.global.success('La promoción ha sido modificada correctamente.');
    } catch (e) {
      const errorMessage = handleErrorMessage(e, 'Ocurrió un error al editar la promoción.');
      showNotificationError(errorMessage);
      throw e;
    }
  },
);

export const editYapePromotionReducer: TSliceExtraReducer<IYapeState> = builder =>
  builder
    .addCase(editYapePromotion.pending, state => {
      state.promo.form.loading = true;
      state.promo.form.success = false;
    })
    .addCase(editYapePromotion.rejected, state => {
      state.promo.form.loading = false;
      state.promo.form.success = false;
    })
    .addCase(editYapePromotion.fulfilled, state => {
      state.promo.form.loading = false;
      state.promo.form.success = true;
    });
